var exports = {
  "w": "x93eb46d8--f923a8--header",
};

module.exports = exports;
